import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import * as routes from '../../constants/routes';
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles';
//import Button from '@material-ui/core/Button';
//import Typography from '@material-ui/core/Typography';
import Home from '../../Container/Content/Home/Home'
import { watchAdminCounters } from '../../firebase/database/handleCounter'

const styles = theme => ({
  root: {
    
  },
  navTitle: {
      color: 'white',
      fontWeight: 'bold',
      textTransform: 'uppercase'
      
  },
  paper: {
    padding: '10px',
    backgroundColor: '#3f51b5',
    height: '80px',
    maxWidth: '200px',
    cursur: 'pointer'
    },
    wrapper: {
        

    }

});




class AdminHome extends Component {

    componentDidMount () {
        watchAdminCounters()
        
    }

    componentWillUnmount () {
        watchAdminCounters(false)
    }

    
    render () {
        const navItems = [
            {
                lable: 'Hilfebedarf vermitteln',
                route: routes.ADMINEVENTS,
                counter: this.props.counter.events,
            },
           /* {
                lable: 'Hilfegesuche mit Angebot',
                route: routes.ADMINCANIDATELIST,
                counter: 2,
            }, */
            {
                lable: 'Hilfebedarf bestätigen',
                route: routes.ADMIN_CONNECTED_EVENTS,
                counter: this.props.counter.connectedEvents,
            },
            {
                lable: ' Hilfebedarf abgeschlossen',
                route: routes.ADMIN_CONFIRMED_EVENTS,
                counter: this.props.counter.confirmedEvents, 
            },
            {
                lable: 'Hilfebedarf für Mitglied erstellen',
                route: routes.ADMIN_ADD_EVENT,
                counter: 0,
            },
            {
                lable: 'Mitglieder freischalten',
                route: routes.ADMIN_USER_MGM,
                counter: this.props.counter.importedUsers,
            },
            {
                lable: 'App Benutzer deaktivieren',
                route: routes.ADMIN_UNLOCKED_USER,
                counter: this.props.counter.users,
            },
            {
                lable: 'App Benutzer online',
                route: routes.ADMIN_USERS_ONLINE,
                counter: this.props.counter.usersOnline,
            }
        ]
        return (
            <Home navItems={navItems}  />
        )
    }
}
    const mapStateToProps = state => ({
        counter: {
            events: state.adminCounter.events,
            connectedEvents: state.adminCounter.connectedEvents,
            confirmedEvents: state.adminCounter.confirmedEvents,
            users: state.adminCounter.users,
            importedUsers: state.adminCounter.importedUsers,
            usersOnline: state.adminCounter.usersOnline,
        }
    })

    
    AdminHome.propTypes = {
        classes: PropTypes.object.isRequired,
      };
    
    export default compose(
        connect(mapStateToProps),
        withRouter,
        withStyles(styles)
        )(AdminHome)


// WEBPACK FOOTER //
// ./src/Components/Admin/AdminHome.js